module.exports = __webpack_public_path__ + "img/racecourse-fairview-turf-2200.e0c7d6e4.svg";